import React from 'react';
import Delete from './delete-study';
import request from '../../../request';
import { Redirect } from 'react-router-dom';
import { UploadField, SignedUploader } from '@navjobs/upload';

export default ({ study, type, onDelete, title, download }) => {
  if (!study) return;
  return (
    <SignedUploader
      beforeRequest={({ files }) => request({
        url: `studies/${study.id}/${type}`,
        method: 'POST',
        body: {
          size: files[0].size,
          content_type: files[0].type,
          extension: files[0].name.split('.').pop(),
        },
      })}
      request={({ before, files }) => ({
        url: before.url,
        method: 'PUT',
        headers: {
          'Content-Type': files[0].type,
        },
      })}
      afterRequest={({ before, files }) => request({
        url: `studies/${study.id}/finish-${type}`,
        method: 'POST',
        body: { path: before.path, size: files[0].size },
      })}
    >
      {(
        {
          onFiles,
          startUpload,
          files,
          progress,
          complete,
          after,
          failed,
          error,
        }
      ) => {
        if (study[`${type}_download_path`])
          return (
            <Delete
              onDelete={onDelete}
              type={type}
              id={study.id}
              redirect={{
                pathname: `/study/${study.id}/`,
                state: {
                  study: {
                    ...study,
                    [`${type}_download_path`]: '',
                    status: type === 'results' ? 'progress' : study.status,
                  },
                },
              }}
              message={
                `Are you sure you want to delete the ${type === 'results' ? 'results' : 'report'}?`
              }
            />
          );
        if (after)
          return (
            <Redirect
              to={{
                pathname: `/study/${after.id}/`,
                state: {
                  study: after,
                  download,
                },
              }}
            />
          );
        return (
          <ul id="filelist">
            <li className="uploaditem">
              <div className="basics">
                <div className="patient">
                  {title
                    ? title
                    : type === 'results'
                        ? `Results for #${study.id}`
                        : `Report for #${study.id}`}
                </div>
              </div>

              {files
                ? <div className="details">
                    <div className="study">{files[0].name}</div>
                    <div className="type" title="1">{type.name}</div>
                    <div className="dash">—</div>
                    <div className="size">
                      {parseFloat(
                        Math.round(files[0].size * 0.000001 * 100) / 100
                      ).toFixed(2)}
                      {' '}
                      MB
                    </div>
                    <UploadField onFiles={onFiles}>
                      <a className="start" style={{ paddingLeft: 10 }}>
                        Change File
                      </a>
                    </UploadField>
                  </div>
                : <div className="details">
                    <UploadField onFiles={onFiles}>
                      <button className="study_start">
                        Choose File
                      </button>
                    </UploadField>
                  </div>}

              {files
                ? failed
                    ? <div className="status">Failed to Upload</div>
                    : <div className="status">
                        <div className="progress">
                          <div
                            className="bar"
                            style={{
                              width: progress ? `${progress}%` : 0,
                            }}
                          />
                        </div>
                        <div className="size">
                          {progress
                            ? `${progress}% - ${parseFloat(Math.round(files[0].size * 0.000001 * progress) / 100).toFixed(2)} / ${parseFloat(Math.round(files[0].size * 0.000001 * 100) / 100).toFixed(2)} MB`
                            : ''}

                        </div>
                      </div>
                : null}

              {files && !failed
                ? progress || progress === 0
                    ? <div className="actions">Uploading...</div>
                    : <div className="actions">
                        <a className="start" onClick={startUpload}>
                          Start
                        </a>
                      </div>
                : null}
            </li>
          </ul>
        );
      }}
    </SignedUploader>
  );
};



// WEBPACK FOOTER //
// ./src/views/dashboard/components/upload.js